import React from 'react';
import { useNotification } from '../context/NotificationContext';
import { CheckCircle2, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useApp } from '../context/AppContext';

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();
  const { t } = useApp();

  const ICONS: Record<string, React.ReactElement> = {
    success: <CheckCircle2 size={20} className="text-emerald-500" />,
    error: <AlertCircle size={20} className="text-red-500" />,
    info: <Info size={20} className="text-blue-500" />,
    warning: <AlertTriangle size={20} className="text-amber-500" />,
  };

  const BORDER_COLORS: Record<string, string> = {
    success: 'border-emerald-500',
    error: 'border-red-500',
    info: 'border-blue-500',
    warning: 'border-amber-500',
  };

  if (notifications.length === 0) return null;

  return (
    <div 
      style={{ top: 'calc(env(safe-area-inset-top) + 1rem)' }}
      className="fixed right-0 left-0 md:left-auto md:right-4 z-[110] w-full max-w-md mx-auto px-4 md:px-0 space-y-3 pointer-events-none"
    >
      {notifications.map(n => (
        <div 
          key={n.id} 
          className={`relative flex items-start gap-3 p-4 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border-l-4 ${BORDER_COLORS[n.type]} animate-in slide-in-from-top-4 fade-in duration-300 pointer-events-auto`}
        >
          <div className="shrink-0 mt-0.5">{ICONS[n.type]}</div>
          <p className="flex-1 text-sm font-medium text-gray-800 dark:text-gray-100 pr-6 leading-snug">
            {n.message}
          </p>
          <button 
            onClick={() => removeNotification(n.id)} 
            className="absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-full"
            aria-label={t('close_notification')}
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;